<template>
  <keep-alive>
    <router-view />
  </keep-alive>
</template>

<script>
export default {
  name: "XVATHome",
  data() {
    return {
    }
  },
  created() { }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/XVAT/XVATHome.vue